import styled from "styled-components";

import { BREAKPOINTS } from "../../../../../app/appConstants";

export const MainBlockContainerStyled = styled.div`
    display: flex;
    width: 100%;
    color: var(--color-base);
    flex-wrap: wrap;
`;

export const MainBlockLeftStyled = styled.div`
    flex: 0 0 57%;
    @media (max-width: ${BREAKPOINTS.large}px) {
        flex-basis: 67%;
    }
    @media (max-width: ${BREAKPOINTS.medium}px) {
        flex-basis: 60%;
    }
    @media (max-width: ${BREAKPOINTS.small}px) {
        flex-basis: 100%;
    }
`;

export const MainBlockRightStyled = styled.div`
    flex: 0 0 43%;
    display: flex;
    justify-content: center;
    @media (max-width: ${BREAKPOINTS.large}px) {
        flex-basis: 33%;
        justify-content: flex-end;
    }
    @media (max-width: ${BREAKPOINTS.medium}px) {
        flex-basis: 40%;
    }
`;

export const ContainerStyled = styled.div`
    margin: -8px;
    display: flex;
    flex-wrap: wrap;
`;

export const ColStyled = styled.div`
    padding: 8px;
    flex: 0 0
`;

export const PrimaryIconContainerStyled = styled.div`
    display: inline-block;
    padding: 16px;
    border-radius: 4px;
    margin-bottom: 24px;
    height: 64px;
    background-color: var(--color-yellow);
    > img {
        height: 32px;
        width: 32px;
    }
    
    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding: 12px;
        height: 48px;
        > img {
            height: 24px;
            width: 24px;
        }
    }
`;